import React from 'react';
import ProgressStep from './ProgressStep';
import styles from './ProgressBar.module.css';

const ProgressBar = ({ currentStep, progressStep, totalSteps, stepsName, isMobile, myAccount }) => {
  // For mobile: just render the simple 2-line progress bar
  if (isMobile) {

    const adjustedStep = currentStep; 
    const progressPercentage = (adjustedStep / (totalSteps+2)) * 100;
    
    return (
      <div className={styles.mobileProgressContainer}>
        <div className={styles.mobileProgressBackground}>
          <div 
            className={styles.mobileProgressFill}
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
      </div>
    );
  }

  // Desktop version remains the same
  const displayCurrent = Math.floor(progressStep);
  const steps = Array.from({ length: totalSteps }, (_, i) => ({ 
    number: i + 1, 
    label: stepsName[i] || '' 
  }));

  return (
    <div className={`${styles.progressBar} ${myAccount ? styles.myAccount : ''}`}>
      {steps.map((step, index) => (
        <ProgressStep
          key={index}
          stepNumber={step.number}
          isActive={index + 1 === displayCurrent}
          isCompleted={index + 1 < displayCurrent}
          isLast={index === steps.length - 1}
          isFirst={index === 0}
          isVisible={true}
          label={step.label}
          myAccount={myAccount}
          progressStep={progressStep}
          segmentIndex={index}
        />
      ))}
    </div>
  );
};

export default ProgressBar;